import React, { useEffect, useState } from "react";
import HiHandThumbUp from "../../assets/icons/thumbsUp";
import FaHeart from "../../assets/icons/heartFilled";
import FaHandHoldingHeart from "../../assets/icons/handHoldingHeart";
import TbBulbFilled from "../../assets/icons/infoBulb";
import FaLaughBeam from "../../assets/icons/smileFace";
import HiOutlineHandThumbUp from "../../assets/icons/thumbsUpOutlined";
import { formatReactionCount, handleLoginPop } from "../../utils/helpers";
import useAuth from "../../hooks/useAuth";
import { handleApiRequest } from "../../services/handleApiRequest";
import { manageStoryReaction } from "../../redux/stories/thunk";

export const reactionsIcons = {
  like: <HiHandThumbUp className="likeIcon" />,
  love: <FaHeart className="loveIcon" />,
  laugh: <FaLaughBeam className="laughIcon" />,
  information: <TbBulbFilled className="informationIcon" />,
  support: <FaHandHoldingHeart className="supportIcon" />,
};

export default function AddReaction({
  savedReaction,
  reactionsCount = 0,
  storyId = "",
  setStoryDetails,
  position = "",
}) {
  const { isAuthenticated } = useAuth();
  const [myReaction, setMyReaction] = useState("");
  const [showReactions, setShowReactions] = useState(false);

  const handleReaction = async (e, reaction) => {
    e.stopPropagation();
    if (!isAuthenticated) return handleLoginPop(true);

    setMyReaction(reaction);
    setShowReactions(false);
    const element = document.getElementById(`reactedIcon-${storyId}`);

    if (element) {
      element.classList.remove("popup");
      requestAnimationFrame(() => {
        element.classList.add("popup");
      });
    }

    setStoryDetails((prev) => ({
      ...prev,
      reactionsCount: myReaction ? prev.reactionsCount : (prev.reactionsCount || 0) + 1,
    }));

    const request = { storyId, reaction };
    const response = await handleApiRequest(manageStoryReaction, request);

    if (!response.status) {
      setStoryDetails((prev) => ({
        ...prev,
        reactionsCount: myReaction ? prev.reactionsCount : (prev.reactionsCount || 0) - 1,
      }));
      setMyReaction("");
    }
  };

  useEffect(() => {
    if (!myReaction) {
      setMyReaction(savedReaction);
    }
  }, [storyId]);

  return (
    <div
      className="reactionContainer"
      onClick={() => setShowReactions(true)}
      onMouseOver={() => setShowReactions(true)}
      onMouseLeave={() => setShowReactions(false)}>
      <button
        className="min-w-70 m-0 bg-header border-secondary-light px-2 pe-3 py-1 py-2 rounded-pill text-small d-flex align-items-center justify-content-center gap-1"
        onClick={(e) => {
          e.stopPropagation();
        }}>
        <span id={`reactedIcon-${storyId}`} className="reactedIcon popup">
          {myReaction ? reactionsIcons[myReaction] : <HiOutlineHandThumbUp />}
        </span>
        <span>{formatReactionCount(reactionsCount)}</span>
      </button>

      <div
        className={`reactionOptionContainer d-flex align-items-center ${
          showReactions ? "opacity-100" : "opacity-0"
        }`}
        style={position === "left" ? { right: 0, left: "unset" } : {}}>
        {Object.keys(reactionsIcons).map((key) => (
          <span className={`reactedIcon`} onClick={(e) => handleReaction(e, key)}>
            {reactionsIcons[key]}
          </span>
        ))}
      </div>
    </div>
  );
}
